import Countdown from "react-countdown";
import {padStart} from "lodash/string";
import {appendUtcTimeZone} from "../helpers/helperFunctions";


const CustomTimer = ({endDate, onTimeUp, mobile, className, isFlashSale = true}) => {

  return (
    <>
      {!!endDate &&
        <div className={`${className ? `${className} `: ''}${mobile ? 'text-xxs' : 'text-xl'} self-start`}>
          <Countdown
            date={new Date(appendUtcTimeZone(endDate))}
            // renderer={mobile ? renderer : rendererWeb}
            renderer={(param) => renderer({...param, mobile, isFlashSale})}
            onComplete={onTimeUp}
          />
        </div>
      }
    </>
  );

};

const renderer = ({
                    hours,
                    minutes,
                    seconds,
                    completed,
                    days,
                    isFlashSale=true,
                    mobile = true
                  }) => {
  if (completed) {
    return <div className="text-center">{isFlashSale ? 'Flash Sale over':'This Campaign is over (won\'t be visible in the app).'}</div>;
  } else {
    // Render a countdown

    return (
      <div className="flex flex-col items-center">
        {isFlashSale && <img
          src="/images/flash-sale-top.png"
          alt="Flash Sale"
          className={mobile ? '' : 'max-w-[320px]'}
        />}
        <div
          className={`flex leading-none items-start ${
            mobile ? 'px-1 mt-2' : 'px-8 mt-3'
          }`}
        >
          <FlashTimers
            value={padStart(days, 2, '0')}
            type="Days"
            mobile={mobile}
          />
          <FlashColon mobile={mobile}/>
          <FlashTimers
            value={padStart(hours, 2, '0')}
            type="Hours"
            mobile={mobile}
          />
          <FlashColon mobile={mobile}/>
          <FlashTimers
            value={padStart(minutes, 2, '0')}
            type="Minutes"
            mobile={mobile}
          />
          <FlashColon mobile={mobile}/>
          <FlashTimers
            value={padStart(seconds, 2, '0')}
            type="Seconds"
            mobile={mobile}
          />
        </div>
      </div>
    );
  }
};

const FlashColon = ({mobile = true}) => (
  <div
    className={`px-1 font-bold text-white ${mobile ? 'text-xs' : 'text-2xl'}`}
  >
    :
  </div>
);
const FlashTimers = ({value, type, mobile = true}) => {
  return (
    <div className="flex leading-none flex-col items-center justify-center space-y-0.5">
      <div
        className={`bg-white text-center font-black rounded leading-none ${
          mobile ? 'px-1.5 text-xs py-1' : 'px-4 text-xl py-2'
        }`}
      >
        {value}
      </div>
      <div
        className={`text-white font-light leading-none ${
          mobile ? 'text-[7px]' : 'text-sm'
        }`}
      >
        {type}
      </div>
    </div>
  );
};

export default CustomTimer;